import { makeQuery } from "utilities/makeQuery"
import { fetchApiJson } from "utilities/fetchApiJson"

/**
 * 
 * @param {{page?: number, perPage?: number}} params 
 * @returns 
 */
export async function getArchiveBooksApi(params) {
  return await fetchApiJson(makeQuery('/api/archive-books', params))
}
